const expertiseItems = [
  {
    category: "Architecture",
    title: "Clean Architecture & Scalable Systems",
    visual: "https://readdy.ai/api/search-image?query=Abstract%20soft%20minimal%20geometric%20composition%20light%20cream%20white%20background%20with%20subtle%20flowing%20translucent%20shapes%2C%20gentle%20curves%2C%20ethereal%20modern%20digital%20art%2C%20clean%20minimal%20elegant%20design&width=600&height=400&seq=lln-exp-light1&orientation=landscape",
    dark: false,
  },
  {
    category: "Performance",
    title: "High-Performance Optimization & Stability",
    visual: "https://readdy.ai/api/search-image?query=Dark%20charcoal%20near%20black%20abstract%20geometric%20composition%20with%20luminous%20chartreuse%20yellow%20green%20accent%20shapes%2C%20sharp%20angular%20forms%2C%20modern%20digital%20art%2C%20high%20contrast%2C%20minimal%20design%2C%20clean%20lines&width=600&height=400&seq=lln-exp-dark&orientation=landscape",
    dark: true,
  },
  {
    category: "Design",
    title: "User-Centered Design & Modern Workflows",
    visual: "https://readdy.ai/api/search-image?query=Abstract%20minimal%20geometric%20composition%20soft%20pearl%20white%20background%20with%20delicate%20translucent%20overlapping%20organic%20forms%2C%20light%20tones%2C%20modern%20digital%20art%2C%20clean%20elegant%20minimal%20sophisticated&width=600&height=400&seq=lln-exp-light2&orientation=landscape",
    dark: false,
  },
];

export default function ExpertiseSection() {
  return (
    <section className="relative w-full bg-background-50 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-20 mb-16 md:mb-20">
          <div className="lg:w-[45%]">
            <p className="text-[clamp(28px,3.2vw,42px)] font-bold text-foreground-300 font-heading leading-[1.2]">
              Core
            </p>
            <p className="text-[clamp(32px,3.6vw,46px)] italic text-foreground-950 font-heading leading-[1.2]">
              Expertise
            </p>
          </div>
          <div className="lg:w-[55%] flex items-end">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
              The team specializes in modern software engineering practices that prioritize reliability, maintainability, and long-term value across every project.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {expertiseItems.map((item, idx) => (
            <div key={idx} className="flex flex-col rounded-2xl overflow-hidden">
              <div className={`relative w-full aspect-[3/2] rounded-2xl overflow-hidden ${item.dark ? 'bg-foreground-900' : 'bg-background-100'}`}>
                <img
                  src={item.visual}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mt-4 px-1">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium uppercase tracking-wider ${item.dark ? 'bg-accent-500/20 text-accent-400' : 'bg-accent-100 text-primary-700'}`}>
                  {item.category}
                </span>
                <h3 className="mt-2 text-lg md:text-xl lg:text-2xl font-bold text-foreground-950 font-heading leading-tight">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}